import * as type from '../actions/types';

const initialState = {
  pending: false,
  success: false,
  error: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.UPDATE_AVERAGE_ORDER_VALUE_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        error: '',
      };
    case type.UPDATE_AVERAGE_ORDER_VALUE_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
      };
    case type.UPDATE_AVERAGE_ORDER_VALUE_FAILURE:
      return {
        ...state,
        pending: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
